<template>
  <transition name="form-fade" appear>
    <base-field-layout ref="fieldLayout" :content="content" :show-get-help="showGetHelp">
      <slot />
      <template #request-help-prompt>
        <request-help-prompt class="request-help" />
      </template>
    </base-field-layout>
  </transition>
</template>

<script>
import BaseFieldLayout from '@/campaign-form-shared/field-layout.vue'
import RequestHelpPrompt from './request-help-prompt.vue'

export default {
  components: { BaseFieldLayout, RequestHelpPrompt },

  props: {
    content: {
      type: Object,
      required: true
    },

    showGetHelp: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    scrollIntoView() {
      this.$refs.fieldLayout.scrollIntoView()
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

.form-fade-enter-from {
  opacity: 0;
}

.form-fade-enter-active {
  transition: opacity .6s ease-in-out;
}

.request-help {
  margin-top: 20px;
  @include breakpoints.screen-xl-only {
    margin-top: 0;
  }
}

</style>
